import React from 'react';

export default class ReportCourtCheck extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'report-court-check-wrapper'}>
        {this.props.pageNo === 2 ? (
          <div>
            <div className={'court-check-heading'}>
              {'Court case(s) that match closely with the name, father’s name and address given.'}
            </div>
            <div className={'court-check-descripton'}>
              <div className={'description-body'}>
                {this.props.personName !== 'null' ? (
                  <div>
                    <div className={'description-heading'}>{'Name:'}</div>
                    <div className={'description-content padding-bottom'}>
                      {this.props.personName}
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                {this.props.fathersName !== 'null' ? (
                  <div>
                    <div className={'description-heading'}>{'Fathers Name:'}</div>
                    <div className={'description-content'}>{this.props.fathersName}</div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div className={'description-body'}>
                {this.props.address !== 'null' ? (
                  <div>
                    <div className={'description-heading'}>{'Address Provided:'}</div>
                    <div className={'description-content'}>{this.props.address}</div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
            <div className={'court-check-search-heading'}>
              {'RESULTS FOUND FOR '}
              {this.props.noOfCases}
              {' CASES'}
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className={'case-wrapper'}>
          {this.props.cases.map((value, index) => {
            if (Math.floor((index + 1) / 3) + 3 === this.props.pageNo + 1) {
              return (
                <div className={'case'} key={index}>
                  <div className={'case-heading'}>
                    {'CASE '}
                    {index + 1}
                  </div>
                  <div className={'case-body'}>
                    {value.name !== 'null' ? (
                      <div className={'case-body-row'}>
                        <div className={'row-title'}>{'Name as per court record'}</div>
                        <div className={'row-content'}>{value.name}</div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {value.id !== 'null' ? (
                      <div className={'case-body-row'}>
                        <div className={'row-title'}>{'Case ID:'}</div>
                        <div className={'row-content'}>{value.id}</div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {value.address !== 'null' ? (
                      <div className={'case-body-row'}>
                        {console.log(value.address)}
                        <div className={'row-title'}>{'Address:'}</div>
                        <div className={'row-content'}>{value.address}</div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {value.name !== 'null' ? (
                      <div className={'case-body-row'}>
                        <div className={'row-title'}>{'Details Link:'}</div>
                        <div className={'row-content link-content'}>
                          <a href={value.link} target='_blank'>
                            {value.link}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

ReportCourtCheck.defaultProps = {
  pageNo: null,
  personName: null,
  fathersName: null,
  address: null,
  noOfCases: null,
  cases: []
};
